<template>
    <div id="login" :style="bg">
        <div class="login-content">
            <div class="left-box">
                <h1 class="d-flex align-items-center">
                    <img :src="loginLogo" :alt="$loginTL.websitName" />
                </h1>
            </div>
            <div class="right-box">
                <login-form />
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from "@/components/login/login-form";
import { mapMutations } from "vuex";
export default {
    name: "login",
    props: {
        data: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            info: this.$loginTL.loginErrorText,
            bg: `background-image:url('./mgmedia/img/login-bg.jpg');`,
            loginLogo: "./mgmedia/img/logo.png",
            captcha: "",
        };
    },

    components: { LoginForm },
    methods: {
        ...mapMutations("global", ["updatePreloadingDone"]),
    },
};
</script>

<style lang="scss">
#login {
    width: 100%;
    height: 100vh;
    position: relative;
    background: {
        repeat: no-repeat;
        position: center center;
        size: cover;
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(#1e1e1e, 0.4);
    }

    .login-content {
        position: relative;
        z-index: 2;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 992px;

        @include flex(center);

        label {
            span {
                color: #595959;
            }
        }

        .left-box,
        .right-box {
            @include flex();
        }

        h1 {
            img {
                width: 350px;
            }
        }

        .right-box {
            width: 446px;
            padding: 32px 48px 48px 48px;
            background-color: $color-white;
            border-radius: $border-radius * 2;
            margin-left: 18.2%;
        }
    }
}
</style>
